/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-danger */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable import/prefer-default-export */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable no-undef */
import React from 'react';
import styles from './fields.module.scss';
import { generatePlaceholderString } from '../../../../helpers/generators.mjs';
import useTranslate from '~hooks/useTranslate/useTranslate';

const getField = (field, handleChange, elements, state) => {
  const { type, id, translationKey, label, placeholder, ...props } = field;

  switch (type) {
    case 'textarea':
      return (
        <div className={styles.textareaGroup || ''}>
          <textarea
            name={id}
            id={id}
            placeholder={useTranslate(placeholder?.translationKey, placeholder?.label)}
            {...props}
            value={elements[id]}
            onChange={(e) => handleChange(e.target.name, e.target.value)}
            className={`${(!state.isValid && elements[id] === '' && styles.invalid) || ''}`}
          />
          {field.maxLength && <span>{`${elements[id].length}/${field.maxLength}`}</span>}
        </div>
      );
    case 'checkbox':
      return (
        <div className={styles.checkboxGroup || ''}>
          {field.options.map((option) => (
            <div key={option.id}>
              <input
                id={option.id}
                name={option.id}
                type={type}
                checked={elements[option.id] === 'true'}
                onChange={(e) => handleChange(e.target.name, e.target.checked.toString())}
                required={!!option?.required}
              />
              <label
                htmlFor={option.id}
                className={`${
                  (!state.isValid && !elements[option.id].length && styles.invalid) || ''
                }`}
                dangerouslySetInnerHTML={{
                  __html: generatePlaceholderString(
                    useTranslate(option.translationKey, option.label),
                    null,
                    option?.link
                  ),
                }}
              />
            </div>
          ))}
        </div>
      );
    case 'radio':
      return (
        <div className={styles.radioGroup || ''}>
          {field.options.map((option) => (
            <div key={option.id}>
              <input
                id={option.id}
                name={id}
                type={type}
                checked={elements[id] === option.label}
                onChange={(e) => handleChange(e.target.name, option.label)}
                autoComplete="on"
              />
              <label
                key={option.id}
                htmlFor={option.id}
                className={`${(!state.isValid && elements[id] === '' && styles.invalid) || ''}`}
              >
                {useTranslate(option.translationKey, option.label)}
              </label>
            </div>
          ))}
        </div>
      );
    case 'select':
      return (
        <select
          id={id}
          aria-label={id}
          name={id}
          defaultValue={elements[id]}
          onChange={(e) => handleChange(e.target.name, e.target.value)}
          className={`${(!state.isValid && elements[id] === '' && styles.invalid) || ''}`}
        >
          {field.showDefault && (
            <option value="">
              {useTranslate(field.defaultTranslationKey, field.defaultLabel)}
            </option>
          )}
          {field.options.map((option) => (
            <option key={option.id} value={option.label}>
              {useTranslate(option.translationKey, option.label)}
            </option>
          ))}
        </select>
      );
    case 'range':
      return (
        <div className={styles.radioGroup || ''}>
          <input
            name={id}
            id={id}
            type={type}
            aria-describedby={id}
            {...props}
            value={elements[id]}
            onChange={(e) => handleChange(e.target.name, e.target.value)}
          />
          <div className={styles.rangeValues || ''}>
            <span>{field.min}</span>
            <span className={`${(!state.isValid && elements[id] === '' && styles.invalid) || ''}`}>
              {elements[id] || 'Selected Value'}
            </span>
            <span>{field.max}</span>
          </div>
        </div>
      );
    default:
      return (
        <input
          name={id}
          id={id}
          type={type}
          aria-label={useTranslate(translationKey, label)}
          aria-describedby={id}
          placeholder={useTranslate(placeholder?.translationKey, placeholder?.label)}
          {...props}
          value={elements[id]}
          onChange={(e) => handleChange(e.target.name, e.target.value)}
          className={`${(!state.isValid && elements[id] === '' && styles.invalid) || ''}`}
          autoComplete={id}
        />
      );
  }
};

export default getField;
